<template>
  <div id="app">
    <div
      class="header-bg"
      :class="{
        'd-none': $route.name != 'home',
        'header-bg--wireless': $store.state.heroWord === 'wireless'
      }"
    ></div>
    <div class="header-bg-overlay" v-if="$route.name === 'home'"></div>
    <nav
      class="navbar navbar-expand-lg navbar-light"
      :class="{ 'sticky-top': scroll || $route.name != 'home' }"
    >
      <div class="container">
        <a class="navbar-brand" href="#">
          <img src="/assets/images/transparent-logo.png" class="logo" />
          <img
            src="/assets/images/logo-horizontal.png"
            class="logo-horizontal"
          />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarID"
          aria-controls="navbarID"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarID">
          <scrollactive
            class="navbar-nav ms-auto"
            :offset="80"
            :duration="200"
            bezier-easing-value="0,0,.0,1"
            v-if="$route.name == 'home'"
          >
            <router-link to="/#home" class="nav-link scrollactive-item"
              >Home</router-link
            >
            <router-link to="/about" class="nav-link scrollactive-item"
              >About Us</router-link
            >
            <router-link to="/hosting" class="nav-link scrollactive-item"
              >Hosting</router-link
            >
            <router-link to="/#plans" class="nav-link scrollactive-item"
              >Broadband Plans</router-link
            >
            <router-link to="/#contact" class="nav-link scrollactive-item"
              >Contact Us</router-link
            >
            <router-link to="/faq" class="nav-link scrollactive-item"
              >FAQ</router-link
            >
            <a
              href="https://crm.tridentnetwork.com.ph/crm/login"
              target="_blank"
              class="nav-link nav-portal"
              >Client Portal</a
            >
          </scrollactive>
          <div class="navbar-nav ms-auto" v-else>
            <router-link to="/#home" class="nav-link">Home</router-link>
            <router-link
              to="/about"
              :class="
                $route.name == 'about' ? 'nav-link is-active' : 'nav-link'
              "
              >About Us</router-link
            >
            <router-link
              to="/hosting"
              :class="
                $route.name == 'hosting' ? 'nav-link is-active' : 'nav-link'
              "
              >Hosting</router-link
            >
            <router-link to="/#plans" class="nav-link"
              >Broadband Plans</router-link
            >
            <router-link to="/#contact" class="nav-link"
              >Contact Us</router-link
            >
            <router-link
              to="/faq"
              :class="$route.name == 'faq' ? 'nav-link is-active' : 'nav-link'"
              >FAQ</router-link
            >
            <a
              href="https://crm.tridentnetwork.com.ph/crm/login"
              target="_blank"
              class="nav-link nav-portal"
              >Client Portal</a
            >
          </div>
        </div>
      </div>
    </nav>
    <hero-header v-if="$route.name == 'home'"></hero-header>
    <router-view />

    <footer class="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <h6>About</h6>
            <p>
              Trident Network is an Internet Service Provider bringing fiber
              and wireless connectivity to communities that mainstream providers
              have left behind. We believe everyone deserves fast, reliable
              internet — no matter where they are.
            </p>
          </div>
          <div class="col-sm-12 col-md-4">
            <h6>Contact</h6>
            <ul class="footer-links">
              <li>
                <i class="fas fa-envelope"></i>
                <a href="mailto:support@tridentnetwork.com.ph">support@tridentnetwork.com.ph</a>
              </li>
              <li>
                <i class="fas fa-flag"></i>
                <a href="mailto:abuse@tridentnetwork.com.ph">abuse@tridentnetwork.com.ph</a>
              </li>
              <li>
                <i class="fas fa-file-alt"></i>
                <a href="mailto:noc@tridentnetwork.com.ph">noc@tridentnetwork.com.ph</a>
              </li>
            </ul>
          </div>
          <div class="col-sm-12 col-md-4">
            <h6>Like us on Facebook</h6>
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FTridentNetwork&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=258048641232162"
              width="100%"
              style="border: none; overflow: hidden"
              scrolling="no"
              frameborder="0"
              allowfullscreen="true"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>
        <hr />
      </div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <p class="copyright-text mb-0">
              Copyright &copy; {{ new Date().getFullYear() }} All Rights
              Reserved by <a href="#">Trident Network</a>.
            </p>
          </div>
          <div class="col-md-6 text-md-end">
            <span class="crafted-text">Handcrafted by Raeywen Regachuelo</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import HeroHeader from "./components/Hero.vue";
export default {
  title: "Trident Network - Home",
  components: {
    HeroHeader
  },
  data() {
    return {
      scroll: false
    };
  },
  created() {
    window.addEventListener("scroll", this.test);
  },
  destroyed() {
    window.removeEventListener("scroll", this.test);
  },
  methods: {
    test() {
      if (window.scrollY >= 500) {
        this.scroll = true;
      } else {
        this.scroll = false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap.scss";
@import "./assets/styles/app.scss";
</style>
